export const PROJECTS_BASE_PATH = 'projects';
